<div class="bg-th-blue mt-0 container-fluid py-2 position-sticky top-0 index-3">
    <div class=" d-flex justify-content-between justify-content-md-end align-content-center">
        <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()" *ngIf="!isDesktop"></i>

        <a class="text-white f18 my-auto dirI d-flex align-items-center">داشبورد ترکیبی <i
                class="fa fa-question-circle my-auto me-2 fa-2x pointer" (click)="guid(39)"></i></a>
    </div>
</div>
<p class="sticky-top fw-bold text-center bg-blue-light py-2" style="top:5.5%">آمار خودروها به صورت کلی</p>
<div echarts [autoResize]="true" [options]="options | async" id="totalVehicles" class="tree-chart border-bottom"></div>

<p class="sticky-top fw-bold text-center bg-blue-light py-2" style="top:5.5%">وضعیت خودروهای سازمانی</p>
<div echarts [autoResize]="true" [options]="options1 | async" id="orgVehiclesStatus" class="tree-chart border-bottom"></div>

<p class="sticky-top fw-bold text-center bg-blue-light py-2" style="top:5.5%">آمار تخلف خودروها</p>
<div echarts [autoResize]="true" [options]="options2 | async" id="vehiclefines" class="tree-chart"></div>

<p class="sticky-top fw-bold text-center bg-blue-light py-2" style="top:5.5%">متوسط عمر خودروها (سال)</p>
<div echarts [autoResize]="true" [options]="options3 | async" id="vehicleLife" class="tree-chart"></div>

<p class="sticky-top fw-bold text-center bg-blue-light py-2" style="top:5.5%">هزینه های تعمیراتی خودروها (میلیون تومان)</p>
<div echarts [autoResize]="true" [options]="options4 | async" id="vehicleRepaircost" class="tree-chart"></div>